module.exports = __webpack_public_path__ + "media/svg/flechenewsletter-fill-8b567fbb.svg";